// Le date arrivano dall'AS400 come numero YYYYMMDD.

// 20240131 -> "31/01/2024"
export function dataItaliana(yyyymmdd) {
    const s = String(yyyymmdd ?? '');
    if (s.length !== 8) return '';
    return `${s.slice(6, 8)}/${s.slice(4, 6)}/${s.slice(0, 4)}`;
}

// "2024-01-31" (input type=date) -> "20240131"
export function dataCompatta(iso) {
    return iso.replaceAll('-', '');
}
